import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { TextInput } from "../../../../../common/form";
import { FormattedMessage } from "react-intl";

class CategorisationOtherFields extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h3>
                    <FormattedMessage id="clients.client.categorisation.otherForm.title" />
                </h3>
                <div className="form-width">
                    <Field
                        id="note"
                        name="note"
                        className="note-description"
                        type="textarea"
                        componentClass="textarea"
                        component={TextInput}
                        required={false}
                        label={<FormattedMessage id="clients.client.categorisation.otherForm.form.note" />}
                    />
                </div>
            </div>
        );
    }
}

CategorisationOtherFields.propTypes = {
    clientClassification: PropTypes.object,
    disabled: PropTypes.bool
};

export default CategorisationOtherFields;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/forms/CategorisationOtherFields.js